import React, { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { auth } from "../../../firebaseConfig";
import { Link } from 'react-router-dom';

export default function ProfileDropdown({ username }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    auth
      .signOut()
      .then(() => {
        console.log("User signed out");
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-4 py-2 text-white rounded-lg hover:bg-[#808080]"
      >
        Hi, {username}
        <ChevronDownIcon className="ml-2 h-5 w-5" />
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-[8px] shadow-lg z-50">
          <ul className="py-1">
            <li>
            <Link
              to="/profile"
              className= "w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
        >
          My Profile
        </Link>
              {/* <a
                href="/my-profile"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                My Profile
              </a> */}
            </li>
            <li>
            <Link
              to="/my-bookings"
              className= "w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
        >
          My Bookings
        </Link>
              {/* <a
                href="/my-bookings"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                My Bookings
              </a> */}
            </li>
            <li>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
